import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="site-theme min-h-screen px-6 py-24 text-center bg-black text-white">
      <h1 data-testid="not-found-title">Page introuvable</h1>
      <p data-testid="not-found-description" className="my-6">Cette adresse ne correspond pas à une page du site.</p>
      <Link data-testid="not-found-home-link" to="/" className="text-yellow-400 underline">Retour à l’accueil</Link>
    </main>
  );
}